import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Container } from 'reactstrap';

const ErrorPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Container>
      <h2>{t('shell.pages.somethingWentWrong')}</h2>
      <p>
        <Link to='/'>{t('shell.pages.goHome')}</Link>
      </p>
    </Container>
  );
};
export default ErrorPage;
